var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content factors-tab"},_vm._l((_vm.criteriaList.children),function(section){return _c('CriteriaGroup',{key:section.uuid,attrs:{"criteriaGroup":section,"unitUuid":_vm.unitUuid,"mode":"formulate"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }